export const CATEGORIES = {
    general: {
        icon: '√x̄', label: 'General',
        tabs: {
            fracciones: { label: 'Fracciones', symbols: [
                { latex: '\\frac{\\placeholder{}}{\\placeholder{}}', display: '⬚/⬚', title: 'Fracción' },
                { latex: '\\tfrac{\\placeholder{}}{\\placeholder{}}', display: '⬚/⬚', title: 'Fracción pequeña', small: true },
                { latex: '\\dfrac{\\placeholder{}}{\\placeholder{}}', display: '⬚/⬚', title: 'Fracción grande' },
                { latex: '\\cfrac{\\placeholder{}}{\\placeholder{}}', display: '⬚/⬚', title: 'Fracción continua' },
            ]},
            division: { label: 'División', symbols: [
                { latex: '\\placeholder{\\LARGE}\\enclose{longdiv}{\\placeholder{}}', display: 'a)b̄', title: 'División larga' },
            ]},
            raices: { label: 'Raíces', symbols: [
                { latex: '\\sqrt{\\placeholder{}}', display: '√⬚', title: 'Raíz cuadrada' },
                { latex: '\\sqrt[\\placeholder{}]{\\placeholder{}}', display: 'ⁿ√⬚', title: 'Raíz n-ésima' },
                { latex: '\\sqrt[3]{\\placeholder{}}', display: '³√⬚', title: 'Raíz cúbica' },
            ]},
            potencias: { label: 'Potencias', symbols: [
                { latex: '\\placeholder{}^{\\placeholder{}}', display: 'xⁿ', title: 'Potencia' },
                { latex: '\\placeholder{}^2', display: 'x²', title: 'Cuadrado' },
                { latex: '\\placeholder{}^3', display: 'x³', title: 'Cubo' },
                { latex: '\\placeholder{}_{\\placeholder{}}', display: 'xₙ', title: 'Subíndice' },
                { latex: 'e^{\\placeholder{}}', display: 'eˣ', title: 'Exponencial' },
                { latex: '\\,^\\placeholder{}\\placeholder{}', display: 'ⁿx', title: 'Superíndice izquierdo' },
            ]},
            delimitadores: { label: 'Paréntesis', symbols: [
                { latex: '(\\placeholder{})', display: '(⬚)', title: 'Paréntesis' },
                { latex: '[\\placeholder{}]', display: '[⬚]', title: 'Corchetes' },
                { latex: '\\{\\placeholder{}\\}', display: '{⬚}', title: 'Llaves' },
                { latex: '|\\placeholder{}|', display: '|⬚|', title: 'Valor absoluto' },
            ]},
            funciones: { label: 'Funciones', symbols: [
                { latex: '\\sin{\\placeholder{}}', display: 'sin', title: 'Seno' },
                { latex: '\\cos{\\placeholder{}}', display: 'cos', title: 'Coseno' },
                { latex: '\\tan{\\placeholder{}}', display: 'tan', title: 'Tangente' },
                { latex: '\\log{\\placeholder{}}', display: 'log', title: 'Logaritmo' },
                { latex: '\\ln{\\placeholder{}}', display: 'ln', title: 'Logaritmo natural' },
                { latex: '\\exp{\\placeholder{}}', display: 'exp', title: 'Exponencial' },
                { latex: '\\max{\\placeholder{}}', display: 'max', title: 'Máximo' },
                { latex: '\\min{\\placeholder{}}', display: 'min', title: 'Mínimo' },
            ]}
        }
    },
    operadores: {
        icon: '∈∞', label: 'Operadores',
        tabs: {
            basicos: { label: 'Básicos', symbols: [
                { latex: '+', display: '+', title: 'Suma' },
                { latex: '-', display: '−', title: 'Resta' },
                { latex: '\\times', display: '×', title: 'Multiplicación' },
                { latex: '\\div', display: '÷', title: 'División' },
                { latex: '\\pm', display: '±', title: 'Más menos' },
                { latex: '\\cdot', display: '·', title: 'Punto' },
            ]},
            relaciones: { label: 'Relaciones', symbols: [
                { latex: '=', display: '=', title: 'Igual' },
                { latex: '\\neq', display: '≠', title: 'No igual' },
                { latex: '<', display: '<', title: 'Menor que' },
                { latex: '>', display: '>', title: 'Mayor que' },
                { latex: '\\leq', display: '≤', title: 'Menor o igual' },
                { latex: '\\geq', display: '≥', title: 'Mayor o igual' },
                { latex: '\\approx', display: '≈', title: 'Aproximado' },
            ]},
            conjuntos: { label: 'Conjuntos', symbols: [
                { latex: '\\in', display: '∈', title: 'Pertenece' },
                { latex: '\\notin', display: '∉', title: 'No pertenece' },
                { latex: '\\subset', display: '⊂', title: 'Subconjunto' },
                { latex: '\\cup', display: '∪', title: 'Unión' },
                { latex: '\\cap', display: '∩', title: 'Intersección' },
                { latex: '\\emptyset', display: '∅', title: 'Vacío' },
            ]},
            logicos: { label: 'Lógicos', symbols: [
                { latex: '\\land', display: '∧', title: 'Y' },
                { latex: '\\lor', display: '∨', title: 'O' },
                { latex: '\\neg', display: '¬', title: 'Negación' },
                { latex: '\\forall', display: '∀', title: 'Para todo' },
                { latex: '\\exists', display: '∃', title: 'Existe' },
            ]},
            varios: { label: 'Varios', symbols: [
                { latex: '\\infty', display: '∞', title: 'Infinito' },
                { latex: '\\partial', display: '∂', title: 'Parcial' },
                { latex: '\\nabla', display: '∇', title: 'Nabla' },
                { latex: '\\angle', display: '∠', title: 'Ángulo' },
            ]},
            largos: { label: 'Operadores Largos', symbols: [
                { latex: '\\sum', display: '∑', title: 'Suma' },
                { latex: '\\prod', display: '∏', title: 'Producto' },
                { latex: '\\coprod', display: '∐', title: 'Coproducto' },
                { latex: '\\int', display: '∫', title: 'Integral' },
                { latex: '\\oint', display: '∮', title: 'Integral cerrada' },
                { latex: '\\bigcup', display: '⋃', title: 'Unión grande' },
                { latex: '\\bigcap', display: '⋂', title: 'Intersección grande' },
                { latex: '\\bigoplus', display: '⨁', title: 'Suma directa' },
                { latex: '\\bigotimes', display: '⨂', title: 'Producto tensorial' },
            ]}
        }
    },
    letras: {
        icon: 'αΩ', label: 'Letras',
        tabs: {
            griegas_min: { label: 'Griegas min.', symbols: [
                { latex: '\\alpha', display: 'α', title: 'Alpha' },
                { latex: '\\beta', display: 'β', title: 'Beta' },
                { latex: '\\gamma', display: 'γ', title: 'Gamma' },
                { latex: '\\delta', display: 'δ', title: 'Delta' },
                { latex: '\\epsilon', display: 'ε', title: 'Epsilon' },
                { latex: '\\theta', display: 'θ', title: 'Theta' },
                { latex: '\\lambda', display: 'λ', title: 'Lambda' },
                { latex: '\\mu', display: 'μ', title: 'Mu' },
                { latex: '\\pi', display: 'π', title: 'Pi' },
                { latex: '\\sigma', display: 'σ', title: 'Sigma' },
                { latex: '\\omega', display: 'ω', title: 'Omega' },
            ]},
            griegas_may: { label: 'Griegas may.', symbols: [
                { latex: '\\Gamma', display: 'Γ', title: 'Gamma' },
                { latex: '\\Delta', display: 'Δ', title: 'Delta' },
                { latex: '\\Theta', display: 'Θ', title: 'Theta' },
                { latex: '\\Lambda', display: 'Λ', title: 'Lambda' },
                { latex: '\\Pi', display: 'Π', title: 'Pi' },
                { latex: '\\Sigma', display: 'Σ', title: 'Sigma' },
                { latex: '\\Omega', display: 'Ω', title: 'Omega' },
            ]},
            especiales: { label: 'Especiales', symbols: [
                { latex: '\\mathbb{N}', display: 'ℕ', title: 'Naturales' },
                { latex: '\\mathbb{Z}', display: 'ℤ', title: 'Enteros' },
                { latex: '\\mathbb{Q}', display: 'ℚ', title: 'Racionales' },
                { latex: '\\mathbb{R}', display: 'ℝ', title: 'Reales' },
                { latex: '\\mathbb{C}', display: 'ℂ', title: 'Complejos' },
            ]}
        }
    },
    matrices: {
        icon: '⌈⌉', label: 'Matrices',
        tabs: {
            matrices: { label: 'Matrices', symbols: [
                { latex: '\\begin{pmatrix} \\placeholder{} & \\placeholder{} \\\\ \\placeholder{} & \\placeholder{} \\end{pmatrix}', display: '(2×2)', title: 'Matriz 2×2', wide: true },
                { latex: '\\begin{bmatrix} \\placeholder{} & \\placeholder{} \\\\ \\placeholder{} & \\placeholder{} \\end{bmatrix}', display: '[2×2]', title: 'Matriz corchetes', wide: true },
                { latex: '\\begin{vmatrix} \\placeholder{} & \\placeholder{} \\\\ \\placeholder{} & \\placeholder{} \\end{vmatrix}', display: '|2×2|', title: 'Determinante', wide: true },
            ]},
            sistemas: { label: 'Sistemas', symbols: [
                { latex: '\\begin{cases} \\placeholder{} \\\\ \\placeholder{} \\end{cases}', display: '{...}', title: 'Sistema 2 ec.' },
                { latex: '\\begin{cases} \\placeholder{} \\\\ \\placeholder{} \\\\ \\placeholder{} \\end{cases}', display: '{...}', title: 'Sistema 3 ec.' },
            ]},
            combinatoria: { label: 'Combinatoria', symbols: [
                { latex: '\\binom{\\placeholder{}}{\\placeholder{}}', display: 'C(n,k)', title: 'Binomial' },
                { latex: '\\placeholder{}!', display: 'n!', title: 'Factorial' },
            ]}

        }
    },
    flechas: {
        icon: '→←', label: 'Flechas',
        tabs: {
            simples: { label: 'Simples', symbols: [
                { latex: '\\leftarrow', display: '←', title: 'Izquierda' },
                { latex: '\\rightarrow', display: '→', title: 'Derecha' },
                { latex: '\\uparrow', display: '↑', title: 'Arriba' },
                { latex: '\\downarrow', display: '↓', title: 'Abajo' },
                { latex: '\\leftrightarrow', display: '↔', title: 'Doble' },
            ]},
            dobles: { label: 'Dobles', symbols: [
                { latex: '\\Leftarrow', display: '⇐', title: 'Izquierda' },
                { latex: '\\Rightarrow', display: '⇒', title: 'Derecha' },
                { latex: '\\Leftrightarrow', display: '⇔', title: 'Doble' },
                { latex: '\\Uparrow', display: '⇑', title: 'Arriba' },
                { latex: '\\Downarrow', display: '⇓', title: 'Abajo' },
            ]},
            especiales: { label: 'Especiales', symbols: [
                { latex: '\\mapsto', display: '↦', title: 'Mapea a' },
                { latex: '\\longmapsto', display: '⟼', title: 'Mapea a (largo)' },
                { latex: '\\longleftarrow', display: '⟵', title: 'Izquierda larga' },
                { latex: '\\longrightarrow', display: '⟶', title: 'Derecha larga' },
                { latex: '\\longleftrightarrow', display: '⟷', title: 'Doble larga' },
                { latex: '\\nearrow', display: '↗', title: 'Noreste' },
                { latex: '\\searrow', display: '↘', title: 'Sureste' },
                { latex: '\\nwarrow', display: '↖', title: 'Noroeste' },
                { latex: '\\swarrow', display: '↙', title: 'Suroeste' },
            ]}
        }
    },
    calculo: {
        icon: 'ΣU', label: 'Cálculo',
        tabs: {
            sumatorias: { label: 'Sumatorias', symbols: [
                { latex: '\\sum_{\\placeholder{}}^{\\placeholder{}} \\placeholder{}', display: 'Σ', title: 'Sumatoria' },
                { latex: '\\prod_{\\placeholder{}}^{\\placeholder{}} \\placeholder{}', display: '∏', title: 'Productoria' },
            ]},
            integrales: { label: 'Integrales', symbols: [
                { latex: '\\int \\placeholder{} \\, d\\placeholder{}', display: '∫', title: 'Integral' },
                { latex: '\\int_{\\placeholder{}}^{\\placeholder{}} \\placeholder{} \\, d\\placeholder{}', display: '∫ᵃᵇ', title: 'Definida' },
                { latex: '\\iint \\placeholder{}', display: '∬', title: 'Doble' },
            ]},
            limites: { label: 'Límites', symbols: [
                { latex: '\\lim_{\\placeholder{} \\to \\placeholder{}} \\placeholder{}', display: 'lim', title: 'Límite' },
                { latex: '\\lim_{x \\to \\infty} \\placeholder{}', display: 'lim∞', title: 'Al infinito' },
            ]},
            derivadas: { label: 'Derivadas', symbols: [
                { latex: '\\frac{d}{d\\placeholder{}}(\\placeholder{})', display: 'd/dx', title: 'Derivada', wide: true },
                { latex: '\\frac{\\partial}{\\partial \\placeholder{}}(\\placeholder{})', display: '∂/∂x', title: 'Parcial' },
                { latex: "\\placeholder{}'", display: "f'", title: 'Prima' },
            ]}
        }
    },
    trigonometria: {
        icon: 'sin', label: 'Trigonometría',
        tabs: {
            basicas: { label: 'Básicas', symbols: [
                { latex: '\\sin{\\placeholder{}}', display: 'sin', title: 'Seno' },
                { latex: '\\cos{\\placeholder{}}', display: 'cos', title: 'Coseno' },
                { latex: '\\tan{\\placeholder{}}', display: 'tan', title: 'Tangente' },
                { latex: '\\cot{\\placeholder{}}', display: 'cot', title: 'Cotangente' },
            ]},
            inversas: { label: 'Inversas', symbols: [
                { latex: '\\arcsin{\\placeholder{}}', display: 'arcsin', title: 'Arcoseno', wide: true },
                { latex: '\\arccos{\\placeholder{}}', display: 'arccos', title: 'Arcocoseno', wide: true },
                { latex: '\\arctan{\\placeholder{}}', display: 'arctan', title: 'Arcotangente', wide: true },
            ]},
            hiperbolicas: { label: 'Hiperbólicas', symbols: [
                { latex: '\\sinh{\\placeholder{}}', display: 'sinh', title: 'Senh' },
                { latex: '\\cosh{\\placeholder{}}', display: 'cosh', title: 'Cosh' },
                { latex: '\\tanh{\\placeholder{}}', display: 'tanh', title: 'Tanh' },
            ]}
        }
    },
    espaciados: {
        icon: '⎵⎵', label: 'Espaciados',
        tabs: {
            espacios: { label: 'Espacios', symbols: [
                { latex: '\\,', display: '⎵', title: 'Espacio fino' },
                { latex: '\\:', display: '⎵⎵', title: 'Espacio medio' },
                { latex: '\\;', display: '⎵⎵⎵', title: 'Espacio grueso' },
                { latex: '\\quad', display: '⎵⎵⎵⎵', title: 'Espacio muy grueso' },
                { latex: '\\qquad', display: '⎵⎵⎵⎵⎵', title: 'Espacio enorme' },
            ]},
            negativos: { label: 'Negativos', symbols: [
                { latex: '\\!', display: '-⎵', title: 'Espacio negativo' },
            ]}
        }
    },
    decoracion: {
        icon: 'x̄ŷ', label: 'Decoración',
        tabs: {
            acentos: { label: 'Acentos', symbols: [
                { latex: '\\bar{\\placeholder{}}', display: 'x̄', title: 'Barra' },
                { latex: '\\hat{\\placeholder{}}', display: 'x̂', title: 'Sombrero' },
                { latex: '\\tilde{\\placeholder{}}', display: 'x̃', title: 'Tilde' },
                { latex: '\\vec{\\placeholder{}}', display: 'v⃗', title: 'Vector' },
                { latex: '\\dot{\\placeholder{}}', display: 'ẋ', title: 'Punto' },
                { latex: '\\ddot{\\placeholder{}}', display: 'ẍ', title: 'Doble punto' },
            ]},
            lineas: { label: 'Líneas', symbols: [
                { latex: '\\overline{\\placeholder{}}', display: 'x̅', title: 'Línea superior' },
                { latex: '\\_', display: 'x̲', title: 'Línea inferior' },
                { latex: '\\overrightarrow{\\placeholder{}}', display: 'AB⃗', title: 'Flecha superior' },
                { latex: '\\overleftarrow{\\placeholder{}}', display: '⃖AB', title: 'Flecha izq. superior' },
            ]},
            cajas: { label: 'Cajas', symbols: [
                { latex: '\\boxed{\\placeholder{}}', display: '⬚', title: 'Caja' },
                { latex: '{\\placeholder{}}', display: '▢', title: 'Caja con marco' },
                { latex: '\\colorbox{yellow}{\\placeholder{}}', display: '🟨', title: 'Fondo amarillo' },
            ]},
            tachados: { label: 'Tachados', symbols: [
                { latex: '\\cancel{\\placeholder{}}', display: 'x̸', title: 'Cancelar' },
                { latex: '\\bcancel{\\placeholder{}}', display: 'x⃥', title: 'Cancelar inverso' },
                { latex: '\\xcancel{\\placeholder{}}', display: 'x⃠', title: 'Cancelar X' },
            ]}
        }
    }
    // Nota: Op. Verticales removido - usar el creador de matrices en su lugar
};
